// The small navigation surface the components use (href-style Link, push/replace), on top of
// react-router.
import { forwardRef, useMemo, type AnchorHTMLAttributes } from 'react';
import { Link as RouterLink, useNavigate, useSearchParams as useRouterSearchParams } from 'react-router';

export { useParams } from 'react-router';

/** The current query string (read-only; pages update it with router.replace). */
export function useSearchParams(): URLSearchParams {
  return useRouterSearchParams()[0];
}

type LinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & { href: string };

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link({ href, ...rest }, ref) {
  return <RouterLink ref={ref} to={href} {...rest} />;
});

/** Stable across renders (effects depend on it), like Next's useRouter. */
export function useRouter() {
  const navigate = useNavigate();
  return useMemo(() => ({
    push: (to: string) => { void navigate(to); },
    replace: (to: string, _opts?: { scroll?: boolean }) => { void navigate(to, { replace: true, preventScrollReset: true }); },
  }), [navigate]);
}
